@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.change-shipping-line {
  background: v.$palette-blue-light-1;
  border-radius: 6px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 10px 16px;
}

.icon {
  margin-right: 16px;
}

.text {
  background: v.$palette-purple;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.button {
  margin-left: auto;

  padding: 0;
  border: none;
  outline: none;
  appearance: none;
  cursor: pointer;
  background: transparent;
  &::-moz-focus-inner {
    border: 0;
  }

  text-decoration: underline;
  color: v.$palette-purple-light;
}

.button,
.text {
  @include t.text(14px, 22px, 500);
}